export interface Device_MANUFACTURE_Detail_Interface {
  id:number,
  mANUFACTURE_id:number,
  rANGE_MIN:String,
  rANGE_MAX:String,
  rANGE_Vahed_id:number,
  rANGE_Vahed:String,
  rESOLUTION:String,
  rESOLUTION_Vahed_id:number,
  rESOLUTION_Vahed:String,
  username:String,
  persianDate:String,
  del:boolean,
}

export function Empty_Device_MANUFACTURE_Detail_Interface():Device_MANUFACTURE_Detail_Interface{
    return{
      id:0,
      mANUFACTURE_id:0,
      rANGE_MIN:'',
      rANGE_MAX:'',
      rANGE_Vahed_id:0,
      rANGE_Vahed:'',
      rESOLUTION:'',
      rESOLUTION_Vahed_id:0,
      rESOLUTION_Vahed:'',
      username:'',
      persianDate:'',
      del:false,
    }
  }
